/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { CustomLabel6, Table } from '@4beefopag/4bee-fopag-core/dist/atoms';
import PropTypes from 'prop-types';
import { Total } from '../../atoms/Apontamento';
import { parametrizacaoProps } from '../../atoms/Props';
import { Cell, Header, HeaderWithSort } from '../../atoms/Table';
import ColaboradorMensal from '../../molecules/ColaboradorMensal';
import LegendaSituacaoColaborador from '../../molecules/LegendaSituacaoColaborador';
import { Wrapper } from './tabelaMensal.styled';

function TabelaMensal({
  onChangeItemValues,
  payrollId,
  isEditable,
  totals,
  parametrizacao,
  onChangeOrder,
  orderBy,
  items,
  createdByActorKind,
}) {
  const clickOrderBy = (key, value) => {
    onChangeOrder({ [key]: value });
  };

  return (
    <Wrapper>
      <Table
        widthInput="112px"
        background="#f6f7f9"
        borderBottomTh="1px solid #e8e8e8"
        borderBottomTd="1px solid #e8e8e8"
        style={{ width: '100%' }}
      >
        <thead>
          <tr>
            <Header
              fixed
              width="100px"
              left="0px"
            >
              <CustomLabel6>CPF</CustomLabel6>
            </Header>
            <HeaderWithSort
              orderType={orderBy['cooperator.name']}
              clickOnOrder={(orderType) => clickOrderBy('cooperator.name', orderType)}
              width="210px"
              left="100px"
              label="Nome"
              fixed
            />
            <HeaderWithSort
              orderType={orderBy.diasTrabalhados}
              clickOnOrder={(orderType) => clickOrderBy('diasTrabalhados', orderType)}
              width="128px"
              label="Dias Trabalhados"
            />
            <HeaderWithSort
              orderType={orderBy.baseHora}
              clickOnOrder={(orderType) => clickOrderBy('baseHora', orderType)}
              width="128px"
              label="Horas Trabalhadas"
            />
            <HeaderWithSort
              orderType={orderBy.hourlyRate}
              clickOnOrder={(orderType) => clickOrderBy('hourlyRate', orderType)}
              width="128px"
              label="Valor Hora"
            />
            <HeaderWithSort
              orderType={orderBy['cooperator.monthlyEstimate']}
              clickOnOrder={(orderType) => clickOrderBy('cooperator.monthlyEstimate', orderType)}
              width="128px"
              label="Remuneração Base"
            />
            <HeaderWithSort
              orderType={orderBy.producao}
              clickOnOrder={(orderType) => clickOrderBy('producao', orderType)}
              width="128px"
              label="Produção"
            />
            <HeaderWithSort
              orderType={orderBy.variavel}
              clickOnOrder={(orderType) => clickOrderBy('variavel', orderType)}
              width="128px"
              label="Variável"
            />
            <HeaderWithSort
              orderType={orderBy.reembolso}
              clickOnOrder={(orderType) => clickOrderBy('reembolso', orderType)}
              width="128px"
              label="Reembolso"
            />
            <HeaderWithSort
              orderType={orderBy.totalRendimentos}
              clickOnOrder={(orderType) => clickOrderBy('totalRendimentos', orderType)}
              width="128px"
              label="Total Rendimentos"
            />
            <HeaderWithSort
              orderType={orderBy.descontosDiversos}
              clickOnOrder={(orderType) => clickOrderBy('descontosDiversos', orderType)}
              width="128px"
              label="Descontos Diversos"
            />
            <HeaderWithSort
              orderType={orderBy.adiantamento}
              clickOnOrder={(orderType) => clickOrderBy('adiantamento', orderType)}
              width="128px"
              label="Adiantamento"
            />
            <HeaderWithSort
              orderType={orderBy.totalDebitos}
              clickOnOrder={(orderType) => clickOrderBy('totalDebitos', orderType)}
              width="128px"
              label="Total Débitos"
            />
            <HeaderWithSort
              orderType={orderBy.liquido}
              clickOnOrder={(orderType) => clickOrderBy('liquido', orderType)}
              width="128px"
              label="Líquido"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((itemMensal) => (
            <ColaboradorMensal
              itemMensal={itemMensal}
              payrollId={payrollId}
              isEditable={isEditable}
              key={itemMensal.id}
              onChangeItemValues={onChangeItemValues}
              parametrizacao={parametrizacao}
              createdByActorKind={createdByActorKind}
            />
          ))}
          <tr>
            <Cell
              colSpan="3"
              fixed
              width="210px"
              left="0px"
            >
              <LegendaSituacaoColaborador />
            </Cell>
            <td />
            <td />
            <td />
            <Total>{totals.producao}</Total>
            <Total>{totals.variavel}</Total>
            <Total>{totals.reembolso}</Total>
            <Total>{totals.totalRendimentos}</Total>
            <Total>{totals.descontosDiversos}</Total>
            <Total>{totals.adiantamento}</Total>
            <Total>{totals.totalDebitos}</Total>
            <Total>{totals.liquido}</Total>
          </tr>
        </tbody>
      </Table>
    </Wrapper>
  );
}
TabelaMensal.propTypes = {
  totals: PropTypes.shape().isRequired,
  onChangeItemValues: PropTypes.func.isRequired,
  parametrizacao: parametrizacaoProps,
  onChangeOrder: PropTypes.func.isRequired,
  orderBy: PropTypes.shape().isRequired,
  items: PropTypes.arrayOf(),
  payrollId: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
  createdByActorKind: PropTypes.string,
};

TabelaMensal.defaultProps = {
  parametrizacao: {},
  items: [],
  createdByActorKind: undefined,
};

export default TabelaMensal;
